import {h, data, text} from './h'

export function Title() {
  h('h1', () => {
    data({section: 'app-title'})
    text('ANODE')
  })
}
